import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col items-center text-center mt-32 mb-36 mx-auto w-72"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg leading-relaxed text-cebai-grey-dark" }, " Please sign up or log in to access learning resources ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GuidancePrompts = _resolveComponent("GuidancePrompts")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_WarningIcon = _resolveComponent("WarningIcon")!
  const _component_GuidedTour = _resolveComponent("GuidedTour")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_GuidancePrompts, { type: "learning" }),
          _createVNode(_component_Tabs, {
            "active-tab": _ctx.activeTab,
            "uses-router": true,
            "has-content": false,
            tabs: _ctx.tabs,
            "tab-type": "underlined"
          }, null, 8, ["active-tab", "tabs"]),
          _createVNode(_component_router_view)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_WarningIcon, { class: "mb-4" }),
          _hoisted_3
        ])),
    _createVNode(_component_GuidedTour, { name: "challenge-learning" })
  ], 64))
}